import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const MiniCartAddedItems = () => {
  const salesQuotationId = useSelector((state) => state.cart.salesQuotationId),
        orderRows = useSelector((state) => state.cart.orderRows),
        addedProducts = useSelector((state) => state.cart.addedProducts);
  const productsToShow = (addedProducts || [])
    .map(pid => orderRows.find(r =>
      r.articleNumber === pid))
    .filter(Boolean);

  useEffect(() => {
    let anchor = document.querySelector('.anchor-mini-cart');
    
    if(anchor) {
      anchor.dataset.count = orderRows.length.toString();
    }
    
    if(salesQuotationId) {
      console.group("%cBE Group", "color: #003b67; font-size: 16px; font-weight: bold;");
      console.log("SalesQuotationId", salesQuotationId);
      console.groupEnd();
    }
  }, [orderRows]);

  return (
      <ul className="mini-cart-menu__list">
        {productsToShow.map((p) => (
          <li key={p.articleNumber}>
            <img src={p.image} />
            <span>{p.name}</span>
          </li>
        ))}
      </ul>
  );
};

export default MiniCartAddedItems;
